// Shared high-resolution 3D assets for the board, preview and collection book.
export const MONSTER_ASSETS = Array.from({ length: 11 }, (_, level) =>
  `/assets/monsters/monster-${String(level + 1).padStart(2, '0')}.webp`);

export function createMonsterSprites(): HTMLImageElement[] {
  return MONSTER_ASSETS.map(src => {
    const image = new Image();
    image.decoding = 'async';
    image.src = src;
    return image;
  });
}
export function spritesReady(sprites: HTMLImageElement[]): boolean {
  return sprites.every(image => image.complete && image.naturalWidth > 0);
}
